import { Component } from '@angular/core';
import { AdditionalModalDismissReasons } from '@app/modules/modals/enums/additional-modal-dismiss-reasons';
import { Modal } from '@app/modules/modals/modals.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * This component's current sole purpose is to be called via the showWhiteModalBackdrop method
 * of the ModalService to utilize the backdrop that's built into the modal. This dummy modal
 * has no body, since we use display: none for the window class in this use case, which hides it.
 */
@Component({
    selector: 'fdx-dummy-modal',
    templateUrl: './dummy-modal.component.html',
    standalone: false
})
export class DummyModalComponent implements Modal {

    constructor(
        private readonly modal: NgbActiveModal
    ) {}

    public onModalBackdropClick(): void {
        this.modal.dismiss(AdditionalModalDismissReasons.BACKDROP_CLICK);
    }
}
